const QuickExit = () => {
  const handleExit = () => {
    // Open decoy tabs to bury history
    window.open("https://www.weather.com", "_blank");
    window.open("https://www.google.com", "_blank");
    // Replace current entry so Back button won't return here
    window.location.replace("https://www.weather.com");
  };

  return (
    <button
      onClick={handleExit}
      className="quick-exit-button fixed bottom-12 right-8 z-[100] bg-destructive text-destructive-foreground px-4 py-2 rounded-md font-body font-medium text-xs uppercase tracking-wider shadow-lg hover:opacity-90 transition-opacity"
    >
      Quick Exit
    </button>
  );
};

export default QuickExit;
